import {
  GET_HISTORYSTATUS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_HISTORYSTATUS,
  DELETE_HISTORYSTATUS,
} from './actionType';

// common success
export const HistoryStatusApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const HistoryStatusApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetHistoryStatus = (id) => ({
  type: GET_HISTORYSTATUS,
  payload: { id },
});

export const CreateHistoryStatus = (data) => ({
  type: CREATE_HISTORYSTATUS,
  payload: { data },
});

export const DeleteHistoryStatus = (id) => ({
  type: DELETE_HISTORYSTATUS,
  payload: { id },
});
